import { z } from 'zod'

/**
 * Environment contract for hafizalquran.
 * Keys and requirements mirror apps/hafizalquran/.env.production (source of truth).
 */

const requiredString = name => z.string().trim().min(1, `${name} is required`)
const requiredUrl = name => requiredString(name).url(`${name} must be a valid URL`)

export const publicEnvSchema = z.object({
  NEXT_PUBLIC_HAFIZ_BASE_URL: requiredUrl('NEXT_PUBLIC_HAFIZ_BASE_URL'),
  NEXT_PUBLIC_APP_VERSION: requiredString('NEXT_PUBLIC_APP_VERSION'),
  NEXT_PUBLIC_R2_BASE_URL: requiredUrl('NEXT_PUBLIC_R2_BASE_URL'),
  NEXT_PUBLIC_HAFIZ_TURNSTILE_SITE_KEY: requiredString('NEXT_PUBLIC_HAFIZ_TURNSTILE_SITE_KEY'),
})

export const serverEnvSchema = z.object({
  PORT: z.coerce.number().int().positive().optional(),
  NODE_ENV: z.enum(['development', 'production', 'test']).default('development'),

  API_BASE_URL: requiredUrl('API_BASE_URL'),
  HAFIZ_PORTAL_API_KEY: requiredString('HAFIZ_PORTAL_API_KEY'),
  HAFIZ_ACADEMY_ID: z.coerce.number().int().positive('HAFIZ_ACADEMY_ID must be a positive number'),
  HAFIZ_TURNSTILE_SECRET_KEY: requiredString('HAFIZ_TURNSTILE_SECRET_KEY'),
  HAFIZ_REVALIDATION_SECRET: requiredString('HAFIZ_REVALIDATION_SECRET'),

  // Present in .env.example; commented out in .env.production
  NEW_RELIC_LICENSE_KEY: z.string().trim().optional(),
  NEW_RELIC_BROWSER_APP_ID: z.string().trim().optional(),
  NEW_RELIC_USER_KEY: z.string().trim().optional(),
  NEW_RELIC_REGION: z.string().trim().optional(),
  NEW_RELIC_ENABLED: z.enum(['true', 'false']).optional(),
})

export const envSchema = z.intersection(serverEnvSchema, publicEnvSchema)

export function validatePublicEnv(config) {
  const result = publicEnvSchema.safeParse(config)

  if (!result.success) {
    console.error('Invalid hafizalquran public environment variables:', result.error.format())
    throw new Error('hafizalquran public environment validation failed.')
  }

  return result.data
}

export function validateEnv(config) {
  const result = envSchema.safeParse(config)

  if (!result.success) {
    console.error('Invalid hafizalquran environment variables:', result.error.format())
    throw new Error('hafizalquran environment validation failed.')
  }

  return result.data
}
